"use client";

import React, { useEffect, useState } from "react";
import Form from "./Form/Form";
import ChartOverlay from "./ChartOverlay/ChartOverlay";

import ReactGA from "react-ga4";

import utils from "../utils/utils";

import axios from "axios";
import Loading from "./Loading/Loading";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";

const Home: React.FC = () => {
  const [dollars, setDollars] = useState("0");
  const [dollarValue, setDollarValue] = useState();
  const [mainCoin, setMainCoin] = useState("usd");
  const [historicalData, setHistoricalData] = useState([]);
  const [isChartOpen, setIsChartOpen] = useState(false);

  const getDolarValue = () => {
    axios
      .get(utils.api)
      .then(function (response) {
        setDollarValue(response.data.dolar.valor);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getHistoricalData = () => {
    axios
      .get(utils.apiHistorical)
      .then(function (response) {
        setHistoricalData(response.data.serie);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleCoinChange = (value: string, dollarValue: number = 0) => {
    const cleanedValue = value.replace(/[^0-9.]/g, "");
    const parsedValue = +cleanedValue;
    const formatter = new Intl.NumberFormat("en-US", { currency: "USD" });

    const pesosToDollars = formatter.format(parsedValue * dollarValue);
    const dollarsToPesos = formatter.format(parsedValue / dollarValue);

    return mainCoin === "usd"
      ? `Pesos Chilenos: ${pesosToDollars}`
      : `Dólares: ${dollarsToPesos}`;
  };

  useEffect(() => {
    ReactGA.initialize("G-7X6B4LHFWL", {
      gaOptions: {
        anonymizeIp: true,
      },
    });
    getDolarValue();
    getHistoricalData();
    ReactGA.send({ hitType: "pageview" });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 to-blue-950 flex flex-col">
      <Header 
        dolar={dollarValue} 
        historicalData={historicalData}
        onChartClick={() => setIsChartOpen(true)}
      />
      <main className="flex-1 py-6 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
        <div className="w-full max-w-md">
          {dollarValue ? (
            <Form
              dollars={dollars}
              setDollars={setDollars}
              mainCoin={mainCoin}
              setMainCoin={setMainCoin}
              handleCoinChange={() => handleCoinChange(dollars, dollarValue)}
            />
          ) : (
            <Loading />
          )}
        </div>
      </main>
      <Footer />
      
      <ChartOverlay 
        isOpen={isChartOpen}
        onClose={() => setIsChartOpen(false)}
        historicalData={historicalData}
      />
    </div>
  );
};

export default Home;
